<template>
  <div class="home">
    <div class="banner">
      <banner></banner>
    </div>
    <div class="contests" id="contests">
      <h2 class="text-center home-heading">Explore Contests</h2>
      <contests class="contests-wrapper"></contests>
    </div>
    <div class="photographers-public-view" id="photographers">
      <h2 class="text-center home-heading">Discover Photographers</h2>
      <photographers></photographers>
    </div>
    <div class="contests" id="courses">
      <h2 class="text-center home-heading">Learn Photography</h2>
      <course-list class="courses-wrapper"></course-list>
    </div>
    <div class="about-us" id="about-us">
      <about-us></about-us>
    </div>
    <div class="services" id="services">
      <h2 class="text-center home-heading">Our Services</h2>
      <services></services>
    </div>
  </div>
</template>

<script>
import CourseList from "../tutorial/CourseList.vue";
import Photographers from "../photographer/Photographers.vue";
import Contests from "../photography-competition/Contests.vue";
import AboutUs from "./AboutUs.vue";
import Banner from "./Banner.vue";
import Services from "./Services.vue";

export default {
  name: "Home",
  components: {
    Banner,
    AboutUs,
    Contests,
    Photographers,
    Services,
    CourseList,
  },
};
</script>

<style scoped>
.banner {
  padding: 0 3rem;
  margin-top: 2rem;
}

.about-us {
  padding: 0 3rem;
  margin-top: 5rem;
}

.contests,
.photographers-public-view {
  margin-top: 5rem;
}

.contests-wrapper,
.courses-wrapper {
  padding: 0 3rem;
}

.home-heading {
  /* margin-top: 5rem; */
}

.services {
  margin-top: 5rem;
}

@media screen and (max-width: 600px) {
  .banner,
  .about-us {
    padding: 0 1rem;
    /* margin-top: 1rem; */
  }

  .home-heading {
    margin: 3rem 1rem 0 1rem;
  }

  .contests-wrapper,
  .courses-wrapper {
    padding: 0 1rem;
  }
}
</style>
